// SPDX-License-Identifier: AGPL-3.0-or-later
// @ts-nocheck — canvas drawing code ported verbatim from the approved design previews.


  const TAU = Math.PI * 2;
  const DPR = 2;
  const rand = (a, b) => a + Math.random() * (b - a);
  const lerp = (a, b, k) => a + (b - a) * k;
  function off(w, h) { const c = document.createElement('canvas'); c.width = Math.ceil(w * DPR); c.height = Math.ceil(h * DPR); const g = c.getContext('2d'); g.scale(DPR, DPR); return [c, g]; }
  function grad(g, x0, y0, x1, y1, stops) { const gr = g.createLinearGradient(x0, y0, x1, y1); stops.forEach(([o, c]) => gr.addColorStop(o, c)); return gr; }
  function radial(g, x, y, r0, r1, stops) { const gr = g.createRadialGradient(x, y, r0, x, y, r1); stops.forEach(([o, c]) => gr.addColorStop(o, c)); return gr; }
  // Additive light: the core of every "premium" look (bloom, glows, rim light).
  function glow(g, x, y, r, rgb, a = 1) {
    g.save(); g.globalCompositeOperation = 'lighter';
    g.fillStyle = radial(g, x, y, 0, r, [[0, `rgba(${rgb},${a})`], [0.35, `rgba(${rgb},${a * 0.35})`], [1, `rgba(${rgb},0)`]]);
    g.fillRect(x - r, y - r, r * 2, r * 2); g.restore();
  }
  function blurred(w, h, px, paint) { const [c, g] = off(w, h); g.filter = `blur(${px}px)`; paint(g); g.filter = 'none'; return c; }
  // Film grain shared by all plates.
  const GRAIN = (() => { const c = document.createElement('canvas'); c.width = c.height = 128; const g = c.getContext('2d'); const d = g.createImageData(128, 128);
    for (let i = 0; i < d.data.length; i += 4) { const v = Math.random() * 255; d.data[i] = d.data[i + 1] = d.data[i + 2] = v; d.data[i + 3] = 26; } g.putImageData(d, 0, 0); return c; })();

  // Finish: soft depth vignette + fine grain, then an opacity ramp so the name side stays see-through.
  function finish(g, w, h, t) {
    g.fillStyle = radial(g, w * 0.75, h * 0.5, h * 0.5, w * 0.8, [[0, 'rgba(0,0,0,0)'], [1, 'rgba(0,0,0,.3)']]);
    g.fillRect(0, 0, w, h);
    g.save(); g.globalCompositeOperation = 'overlay'; g.globalAlpha = 0.35;
    const ox = (t * 37) % 128, oy = (t * 23) % 128;
    for (let x = -ox; x < w; x += 64) for (let y = -oy; y < h; y += 64) g.drawImage(GRAIN, x, y, 64, 64);
    g.restore();
    g.save(); g.globalCompositeOperation = 'destination-in';
    g.fillStyle = grad(g, 0, 0, w, 0, [[0, 'rgba(0,0,0,.02)'], [0.3, 'rgba(0,0,0,.1)'], [0.5, 'rgba(0,0,0,.35)'], [0.7, 'rgba(0,0,0,.75)'], [0.85, 'rgba(0,0,0,1)']]);
    g.fillRect(0, 0, w, h); g.restore();
  }

  /* ------------------------------------------------------------------ plates */
  const PLATES = [];

  // 1. SYNTHWAVE — striped retro sun, racing neon grid, palm silhouettes, starry dusk.
  PLATES.push({
    name: 'Synthwave', sub: 'Retro sürüş', color: '#ff3d9a', accent: '',
    build(w, h, s) {
      s.palm = (() => { const [c, g] = off(40, 48); g.translate(20, 48);
        g.strokeStyle = '#12051e'; g.lineCap = 'round'; g.lineWidth = 2.2; g.beginPath(); g.moveTo(0, 0); g.quadraticCurveTo(4, -22, 1, -38); g.stroke();
        g.fillStyle = '#12051e';
        for (let i = 0; i < 7; i++) { const a = -Math.PI / 2 + (i - 3) * .5; g.save(); g.translate(1, -38); g.rotate(a + Math.PI / 2);
          g.beginPath(); g.moveTo(0, 0); g.quadraticCurveTo(9, -3, 17, 5); g.quadraticCurveTo(9, 1, 0, 2); g.fill(); g.restore(); }
        return c; })();
      s.stars = Array.from({length: 40}, () => [rand(0, w), rand(0, h * .45), rand(0, 6)]);
    },
    draw(g, w, h, t, s) {
      const hz = h * .62;
      g.fillStyle = grad(g, 0, 0, 0, hz, [[0, '#14052e'], [0.55, '#5a0f5e'], [1, '#ff4f8b']]); g.fillRect(0, 0, w, hz);
      for (const [x, y, p] of s.stars) { g.globalAlpha = .3 + .7 * Math.max(0, Math.sin(t * 2 + p)) ** 2; g.fillStyle = '#ffd9f2'; g.fillRect(x, y, .9, .9); }
      g.globalAlpha = 1;
      // Sun with horizontal cut bands that slowly scroll down.
      const sx = w * .76, sy = hz - 2, R = 22;
      glow(g, sx, sy - 8, 60, '255,80,150', .55);
      g.save(); g.beginPath(); g.arc(sx, sy - 6, R, Math.PI, TAU); g.closePath(); g.clip();
      g.fillStyle = grad(g, 0, sy - 6 - R, 0, sy - 6, [[0, '#ffe66b'], [0.5, '#ff9a3c'], [1, '#ff3d9a']]); g.fillRect(sx - R, sy - 6 - R, R * 2, R);
      g.globalCompositeOperation = 'destination-out';
      const off = (t * 3) % 4;
      for (let k = 0; k < 6; k++) { const y = sy - 6 - R * .55 + k * 4 + off; g.fillRect(sx - R, y, R * 2, .6 + k * .45); }
      g.restore();
      // Mountains on the horizon.
      g.fillStyle = '#2a0838'; g.beginPath(); g.moveTo(w * .3, hz);
      for (let x = w * .3; x <= w; x += 4) g.lineTo(x, hz - Math.abs(Math.sin(x * .07)) * 5 - Math.abs(Math.sin(x * .19)) * 3); g.lineTo(w, hz); g.fill();
      // Neon grid floor racing toward the viewer.
      g.fillStyle = grad(g, 0, hz, 0, h, [[0, '#1a0526'], [1, '#07020d']]); g.fillRect(0, hz, w, h - hz);
      g.save(); g.beginPath(); g.rect(0, hz, w, h - hz); g.clip();
      g.strokeStyle = '#ff3dcf'; g.lineWidth = .7; g.shadowColor = '#ff3dcf'; g.shadowBlur = 4;
      const vx = w * .76; g.beginPath();
      for (let i = -14; i <= 14; i++) { g.moveTo(vx + i * 5, hz); g.lineTo(vx + i * 34, h); }
      const z0 = (t * .7) % 1;
      for (let k = 0; k < 8; k++) { const z = (k + z0) / 8, y = hz + (h - hz) * z * z; g.moveTo(0, y); g.lineTo(w, y); }
      g.stroke(); g.restore();
      g.fillStyle = 'rgba(0,240,255,.8)'; g.fillRect(w * .3, hz - .5, w * .7, 1);
      glow(g, w * .76, hz, 50, '0,220,255', .18);
      g.drawImage(s.palm, w * .55, hz - 40, 34, 41); g.drawImage(s.palm, w * .93, hz - 46, 38, 46);
      finish(g, w, h, t);
    },
  });

  // 2. KOI & LOTUS — sunlit pond: light shafts, caustics, two koi circling a glowing lotus.
  PLATES.push({
    name: 'Koi Lotusu', sub: 'Huzur', color: '#ef7a3a', accent: '120,230,210',
    build(w, h, s) {
      s.bg = (() => { const [c, g] = off(w, h);
        g.fillStyle = grad(g, 0, 0, 0, h, [[0, '#0f6a6e'], [1, '#05303a']]); g.fillRect(0, 0, w, h);
        g.globalCompositeOperation = 'lighter';
        for (let i = 0; i < 40; i++) { g.strokeStyle = `rgba(140,255,240,${rand(.03, .08)})`; g.lineWidth = rand(.6, 1.4);
          g.beginPath(); const x = rand(0, w), y = rand(0, h); g.ellipse(x, y, rand(8, 20), rand(3, 6), rand(0, 3), 0, TAU); g.stroke(); }
        return c; })();
      s.lotus = (() => { const [c, g] = off(40, 30); g.translate(20, 22);
        for (const [n, r, col] of [[8, 13, '#f7a8c7'], [6, 9.5, '#ffc5dc'], [5, 6, '#fff0f6']]) for (let i = 0; i < n; i++) {
          g.save(); g.rotate(-Math.PI / 2 + (i - (n - 1) / 2) * (2.6 / n));
          g.fillStyle = grad(g, 0, 0, 0, -r, [[0, '#d0577f'], [0.6, col], [1, '#fff']]);
          g.beginPath(); g.moveTo(0, 0); g.quadraticCurveTo(r * .45, -r * .55, 0, -r); g.quadraticCurveTo(-r * .45, -r * .55, 0, 0); g.fill(); g.restore(); }
        g.fillStyle = '#ffe17a'; g.beginPath(); g.arc(0, -2, 2.2, 0, TAU); g.fill(); return c; })();
      s.koi = [{c1: '#ff6a1f', c2: '#fff4ea', ph: 0, r: 15}, {c1: '#fff', c2: '#e63b25', ph: Math.PI, r: 11}];
    },
    draw(g, w, h, t, s) {
      g.drawImage(s.bg, 0, 0, w, h);
      // Moving light shafts.
      g.save(); g.globalCompositeOperation = 'lighter';
      for (let i = 0; i < 4; i++) { const x = w * (.45 + i * .15) + Math.sin(t * .4 + i) * 10;
        g.fillStyle = grad(g, x, 0, x + 30, h, [[0, 'rgba(180,255,240,.16)'], [1, 'rgba(180,255,240,0)']]);
        g.beginPath(); g.moveTo(x, 0); g.lineTo(x + 10, 0); g.lineTo(x + 34, h); g.lineTo(x + 18, h); g.fill(); }
      g.restore();
      const lx = w * .78, ly = h * .58;
      glow(g, lx, ly - 6, 30, '255,170,210', .45);
      // Koi circling the lotus: tapered spline bodies with spots and soft fins.
      for (const k of s.koi) {
        const a = t * .8 + k.ph, x = lx + Math.cos(a) * (k.r + 22), y = ly + Math.sin(a) * k.r * .5, dir = a + Math.PI / 2;
        g.save(); g.translate(x, y); g.rotate(dir); g.globalAlpha = .95;
        const sw = Math.sin(t * 7 + k.ph) * .5;
        g.fillStyle = 'rgba(0,0,0,.25)'; g.beginPath(); g.ellipse(2, 3, 9, 3, 0, 0, TAU); g.fill();
        g.fillStyle = 'rgba(255,255,255,.35)'; g.beginPath(); g.ellipse(-1, 0, 3, 7, .6, 0, TAU); g.ellipse(-1, 0, 3, 7, -.6, 0, TAU); g.fill();
        g.fillStyle = grad(g, -9, 0, 9, 0, [[0, k.c1], [1, k.c1]]);
        g.beginPath(); g.moveTo(9, 0); g.bezierCurveTo(7, -3.6, -4, -3.2, -9, sw); g.bezierCurveTo(-4, 3.2, 7, 3.6, 9, 0); g.fill();
        g.fillStyle = k.c2; g.beginPath(); g.ellipse(2, -.5, 3, 1.6, .2, 0, TAU); g.ellipse(-3.5, .5, 2, 1.2, -.3, 0, TAU); g.fill();
        g.fillStyle = 'rgba(255,255,255,.55)'; g.beginPath(); g.moveTo(-8, sw); g.lineTo(-14, sw * 2 - 4); g.lineTo(-12.5, sw * 2); g.lineTo(-14, sw * 2 + 4); g.closePath(); g.fill();
        g.restore();
      }
      g.drawImage(s.lotus, lx - 20, ly - 22, 40, 30);
      g.save(); g.globalCompositeOperation = 'lighter';
      for (let i = 0; i < 8; i++) { const a = (Math.sin(t * 1.4 + i * 1.7) + 1) / 2; g.fillStyle = `rgba(200,255,240,${a * .5})`; g.beginPath(); g.arc(w * .5 + (i * 23) % (w * .5), (i * 11) % h, 1.2 + a, 0, TAU); g.fill(); }
      g.restore();
      finish(g, w, h, t);
    },
  });

  // 3. NEON RAIN CITY — cyberpunk street in rain, wet reflections, flickering holo signs.
  PLATES.push({
    name: 'Neon Yağmur', sub: 'Gece 02:47', color: '#ff2bd6', accent: '0,240,255',
    build(w, h, s) {
      const sky = (g) => { g.fillStyle = grad(g, 0, 0, 0, h, [[0, '#0b0624'], [0.7, '#3a0d4a'], [1, '#14051f']]); g.fillRect(0, 0, w, h); };
      s.far = blurred(w, h, 1.2, (g) => { sky(g); for (let x = w * .25; x < w; x += rand(7, 12)) { const bh = rand(h * .45, h * .85); g.fillStyle = '#2a1145'; g.fillRect(x, h * .78 - bh, rand(6, 11), bh); } });
      s.near = (() => { const [c, g] = off(w, h); s.wins = [];
        for (let x = w * .35; x < w; x += rand(14, 22)) { const bw = rand(12, 18), bh = rand(h * .45, h * .78);
          g.fillStyle = grad(g, x, 0, x + bw, 0, [[0, '#0a0614'], [1, '#170b26']]); g.fillRect(x, h * .78 - bh, bw, bh);
          for (let yy = h * .78 - bh + 3; yy < h * .74; yy += 4) for (let xx = x + 2; xx < x + bw - 2; xx += 3.5) if (Math.random() < .35) s.wins.push([xx, yy, Math.random() < .25]); }
        return c; })();
      s.signs = [[w * .6, h * .2, '#ff2bd6'], [w * .78, h * .3, '#00f0ff'], [w * .92, h * .14, '#ffb800']];
      s.rain = Array.from({length: 60}, () => [rand(0, w), rand(0, h), rand(160, 260)]);
    },
    draw(g, w, h, t, s) {
      g.drawImage(s.far, 0, 0, w, h);
      g.drawImage(s.near, 0, 0, w, h);
      for (const [x, y, cyan] of s.wins) { g.fillStyle = cyan ? 'rgba(90,230,255,.85)' : 'rgba(255,200,120,.75)'; g.fillRect(x, y, 1.6, 2); }
      s.signs.forEach(([x, y, col], i) => {
        const on = Math.sin(t * (7 + i * 3) + i) > -0.9 || i !== 1;
        if (!on) return;
        g.fillStyle = col; g.fillRect(x, y, 2, 10); g.fillRect(x + 3, y + 2, 7, 1.6); g.fillRect(x + 3, y + 6, 7, 1.6);
        const rgb = col === '#ff2bd6' ? '255,43,214' : col === '#00f0ff' ? '0,240,255' : '255,184,0';
        glow(g, x + 5, y + 5, 18, rgb, .55);
      });
      // Wet street: mirrored, rippling reflection of the skyline.
      const ry = h * .78;
      g.save(); g.beginPath(); g.rect(0, ry, w, h - ry); g.clip();
      g.globalAlpha = .45; g.translate(0, ry * 2); g.scale(1, -1);
      for (let y = 0; y < h - ry; y += 2) { const dx = Math.sin(t * 3 + y * .9) * 1.4; g.drawImage(s.near, 0, (ry - y - 2) * DPR, w * DPR, 2 * DPR, dx, ry - y - 2, w, 2); }
      g.restore();
      g.fillStyle = grad(g, 0, ry, 0, h, [[0, 'rgba(255,43,214,.25)'], [1, 'rgba(0,240,255,.15)']]); g.fillRect(0, ry, w, h - ry);
      g.strokeStyle = 'rgba(200,220,255,.35)'; g.lineWidth = .6; g.beginPath();
      for (const r of s.rain) { r[1] += r[2] / 60; r[0] -= r[2] / 600; if (r[1] > h) { r[1] = -6; r[0] = rand(0, w + 10); } g.moveTo(r[0], r[1]); g.lineTo(r[0] + .8, r[1] - 6); }
      g.stroke();
      finish(g, w, h, t);
    },
  });

  // 4. CRYSTAL GALAXY — faceted crystals rotating in 3D inside a nebula.
  PLATES.push({
    name: 'Kristal Galaksi', sub: 'Yıldız tozu', color: '#8a5cff', accent: '170,130,255',
    build(w, h, s) {
      s.bg = blurred(w, h, 3, (g) => {
        g.fillStyle = '#07051a'; g.fillRect(0, 0, w, h);
        for (const [x, y, r, c] of [[.7, .3, 40, '120,60,255'], [.9, .7, 34, '255,70,170'], [.55, .8, 28, '40,140,255'], [.95, .2, 22, '80,220,255']])
          { g.fillStyle = radial(g, w * x, h * y, 0, r, [[0, `rgba(${c},.75)`], [1, `rgba(${c},0)`]]); g.fillRect(0, 0, w, h); }
      });
      s.stars = Array.from({length: 60}, () => [rand(0, w), rand(0, h), rand(.3, 1), rand(0, 6)]);
      // Hexagonal bipyramid crystals.
      s.crystals = [{x: .74, y: .5, s: 15, sp: .6, tilt: .3, hue: '170,140,255'}, {x: .9, y: .36, s: 9, sp: -.9, tilt: -.4, hue: '120,220,255'}, {x: .6, y: .62, s: 7, sp: 1.1, tilt: .5, hue: '255,140,220'}];
    },
    draw(g, w, h, t, s) {
      g.drawImage(s.bg, 0, 0, w, h);
      for (const [x, y, r, p] of s.stars) { g.globalAlpha = .3 + .7 * Math.max(0, Math.sin(t * 2 + p)) ** 3; g.fillStyle = '#fff'; g.fillRect(x, y, r, r); }
      g.globalAlpha = 1;
      for (const c of s.crystals) {
        const cx = w * c.x, cy = h * c.y + Math.sin(t * 1.2 + c.s) * 2, rot = t * c.sp;
        glow(g, cx, cy, c.s * 2.6, c.hue, .5);
        const ring = Array.from({length: 6}, (_, i) => { const a = rot + i * TAU / 6; return {x: Math.cos(a) * c.s * .55, z: Math.sin(a) * c.s * .55}; });
        const top = {x: 0, y: -c.s}, bot = {x: 0, y: c.s * .9};
        const faces = [];
        ring.forEach((p, i) => { const q = ring[(i + 1) % 6]; const z = (p.z + q.z) / 2; if (z < -.5) return;
          const shade = .35 + .65 * ((Math.cos(rot + (i + .5) * TAU / 6 - .8) + 1) / 2);
          faces.push([[top.x, top.y], [p.x, p.z * c.tilt], [q.x, q.z * c.tilt], shade, z]);
          faces.push([[bot.x, bot.y], [p.x, p.z * c.tilt], [q.x, q.z * c.tilt], shade * .7, z]); });
        faces.sort((a, b) => a[4] - b[4]);
        g.save(); g.translate(cx, cy);
        for (const [a, b, d, sh] of faces) {
          g.fillStyle = `rgba(${c.hue},${.35 + sh * .5})`; g.strokeStyle = `rgba(255,255,255,${.25 + sh * .5})`; g.lineWidth = .5;
          g.beginPath(); g.moveTo(...a); g.lineTo(...b); g.lineTo(...d); g.closePath(); g.fill(); g.stroke();
        }
        g.restore();
        const sp = Math.max(0, Math.sin(t * 2.4 + c.s)) ** 12;
        if (sp > .05) { g.save(); g.globalAlpha = sp; g.fillStyle = '#fff'; g.fillRect(cx - .5, cy - c.s - 5, 1, 10); g.fillRect(cx - 5, cy - c.s - .5, 10, 1); g.restore(); }
      }
      finish(g, w, h, t);
    },
  });

  // 5. AURORA LAKE — northern lights over snowy peaks, mirrored on a still lake.
  PLATES.push({
    name: 'Aurora Gölü', sub: 'Kutup sessizliği', color: '#2fd39a', accent: '90,255,190',
    build(w, h, s) {
      s.peaks = (() => { const [c, g] = off(w, h * .72); const H = h * .72;
        // Jagged ranges via midpoint displacement, snow caps clipped to the upper slopes.
        const range = (base, rough, col, snow) => {
          let pts = [[0, base], [w, base]];
          for (let d = 0; d < 7; d++) { const o = [pts[0]]; for (let k = 1; k < pts.length; k++) { const [ax, ay] = pts[k - 1], [bx, by] = pts[k]; o.push([(ax + bx) / 2, (ay + by) / 2 - rand(-1, 1) * rough / (d + 1) - (d < 2 ? rand(0, rough * .6) : 0)], [bx, by]); } pts = o; }
          g.save(); g.beginPath(); g.moveTo(0, H); pts.forEach(([x, y]) => g.lineTo(x, Math.min(y, H))); g.lineTo(w, H); g.closePath();
          g.fillStyle = col; g.fill(); g.clip();
          const top = Math.min(...pts.map((p) => p[1]));
          g.fillStyle = grad(g, 0, top, 0, top + 9, [[0, `rgba(235,245,255,${snow})`], [1, 'rgba(235,245,255,0)']]); g.fillRect(0, top, w, 9);
          g.restore();
        };
        range(H * .8, 7, '#1d2c48', .55); range(H * .95, 4, '#0c172a', .35);
        return c; })();
      s.stars = Array.from({length: 45}, () => [rand(0, w), rand(0, h * .6), rand(0, 6)]);
    },
    draw(g, w, h, t, s) {
      const lake = h * .72;
      g.fillStyle = grad(g, 0, 0, 0, lake, [[0, '#030817'], [1, '#0b2440']]); g.fillRect(0, 0, w, lake);
      for (const [x, y, p] of s.stars) { g.globalAlpha = .35 + .65 * Math.max(0, Math.sin(t * 1.6 + p)); g.fillStyle = '#fff'; g.fillRect(x, y, .9, .9); }
      g.globalAlpha = 1;
      g.save(); g.globalCompositeOperation = 'lighter';
      for (let x = w * .2; x < w; x += 1.5) {
        const top = h * .02 + Math.sin(x * .035 + t * .6) * 4 + Math.sin(x * .09 - t * .4) * 2.5;
        const len = h * (.5 + .15 * Math.sin(x * .05 + t * .8));
        const k = (x - w * .2) / (w * .8);
        const c = k < .55 ? '60,255,170' : k < .8 ? '80,200,255' : '190,110,255';
        const b = .35 + .4 * Math.max(0, Math.sin(x * .3 + t * 2.2));
        g.fillStyle = grad(g, 0, top, 0, top + len, [[0, `rgba(${c},0)`], [0.7, `rgba(${c},${b})`], [1, `rgba(${c},0)`]]);
        g.fillRect(x, top, 2.2, len);
      }
      g.restore();
      glow(g, w * .62, h * .18, 40, '60,255,170', .25); glow(g, w * .9, h * .2, 34, '190,110,255', .22);
      g.drawImage(s.peaks, 0, 0, w, lake);
      // Lake mirror with gentle ripple distortion.
      g.save(); g.beginPath(); g.rect(0, lake, w, h - lake); g.clip();
      g.fillStyle = '#04101e'; g.fillRect(0, lake, w, h - lake);
      g.globalAlpha = .55;
      for (let y = 0; y < h - lake; y += 1.5) { const dx = Math.sin(t * 2 + y * 1.3) * .9;
        g.save(); g.translate(dx, lake + y); g.scale(1, -1); g.drawImage(g.canvas, 0, (lake - y - 1.5) * DPR, w * DPR, 1.5 * DPR, 0, -1.5, w, 1.5); g.restore(); }
      g.restore();
      g.strokeStyle = 'rgba(160,255,220,.25)'; g.lineWidth = .5; g.beginPath(); g.moveTo(w * .3, lake + .5); g.lineTo(w, lake + .5); g.stroke();
      finish(g, w, h, t);
    },
  });

  // 6. TORII DUSK — a torii gate against a giant setting sun, layered misty hills, petals.
  PLATES.push({
    name: 'Torii Alacakaranlığı', sub: 'Kutsal geçit', color: '#ff6a3d', accent: '255,150,90',
    build(w, h, s) {
      s.hills = (() => { const [c, g] = off(w, h);
        [[.62, 7, 'rgba(160,60,90,.55)', .03], [.74, 6, 'rgba(110,35,70,.75)', .05], [.88, 5, 'rgba(55,15,40,.95)', .08]].forEach(([b, a, col, f], i) => {
          g.fillStyle = col; g.beginPath(); g.moveTo(0, h);
          for (let x = 0; x <= w; x += 3) g.lineTo(x, h * b - Math.sin(x * f + i * 2) * a - Math.sin(x * f * 2.7) * a * .4);
          g.lineTo(w, h); g.fill();
          g.fillStyle = grad(g, 0, h * b - 6, 0, h * b + 4, [[0, 'rgba(255,200,170,0)'], [1, 'rgba(255,200,170,.18)']]); g.fillRect(0, h * b - 6, w, 10);
        });
        // Torii gate silhouette.
        const tx = w * .82, ty = h * .2, tw = 34;
        g.fillStyle = '#1a0710';
        g.fillRect(tx - tw / 2 + 5, ty + 5, 3, h); g.fillRect(tx + tw / 2 - 8, ty + 5, 3, h);
        g.beginPath(); g.moveTo(tx - tw / 2 - 4, ty + 1); g.quadraticCurveTo(tx, ty - 3, tx + tw / 2 + 4, ty + 1); g.lineTo(tx + tw / 2 + 2, ty + 4); g.quadraticCurveTo(tx, ty + 1, tx - tw / 2 - 2, ty + 4); g.fill();
        g.fillRect(tx - tw / 2 + 2, ty + 9, tw - 4, 2.2); g.fillRect(tx - 1.2, ty + 4, 2.4, 6);
        return c; })();
      s.petals = Array.from({length: 18}, () => ({x: rand(w * .3, w), y: rand(0, h), v: rand(6, 12), r: rand(0, 6)}));
    },
    draw(g, w, h, t, s) {
      g.fillStyle = grad(g, 0, 0, 0, h, [[0, '#3b1450'], [0.45, '#c2406a'], [0.8, '#ff9a55'], [1, '#ffd08a']]); g.fillRect(0, 0, w, h);
      const sx = w * .82, sy = h * .58 + Math.sin(t * .3) * .5;
      glow(g, sx, sy, 60, '255,170,110', .55);
      g.fillStyle = radial(g, sx, sy, 0, 17, [[0, '#fff6dc'], [0.7, '#ffcf8a'], [1, '#ff9a55']]); g.beginPath(); g.arc(sx, sy, 17, 0, TAU); g.fill();
      g.fillStyle = 'rgba(255,170,120,.35)'; for (let i = 0; i < 3; i++) g.fillRect(sx - 20, sy + 4 + i * 3.5, 40, .8);
      g.drawImage(s.hills, 0, 0, w, h);
      g.fillStyle = grad(g, 0, h * .6, 0, h, [[0, 'rgba(255,190,170,0)'], [1, 'rgba(255,190,170,.12)']]); g.fillRect(0, 0, w, h);
      for (const p of s.petals) {
        p.y += p.v / 60; p.x -= p.v / 80 + Math.sin(t * 1.5 + p.r) * .2; p.r += .04;
        if (p.y > h + 3 || p.x < w * .2) { p.y = -3; p.x = rand(w * .4, w + 10); }
        g.save(); g.translate(p.x, p.y); g.rotate(p.r); g.scale(Math.cos(p.r * 2), 1); g.fillStyle = 'rgba(255,190,210,.9)'; g.beginPath(); g.ellipse(0, 0, 2.2, 1.3, 0, 0, TAU); g.fill(); g.restore();
      }
      finish(g, w, h, t);
    },
  });

  // 7. MAGMA CORE — cracked obsidian with magma pulsing through the fissures.
  PLATES.push({
    name: 'Magma Çekirdeği', sub: 'Erime noktası', color: '#ff5a1f', accent: '255,120,40',
    build(w, h, s) {
      s.rock = (() => { const [c, g] = off(w, h);
        g.fillStyle = grad(g, 0, 0, w, h, [[0, '#120806'], [1, '#1f0d08']]); g.fillRect(0, 0, w, h);
        for (let i = 0; i < 120; i++) { g.fillStyle = `rgba(${rand(40, 70) | 0},${rand(20, 35) | 0},${rand(15, 25) | 0},.35)`; g.beginPath(); g.ellipse(rand(0, w), rand(0, h), rand(4, 12), rand(2, 6), rand(0, 3), 0, TAU); g.fill(); }
        return c; })();
      // Fissure network as polylines (drawn live so the glow can pulse along it).
      s.cracks = [];
      const walk = (x, y, a, n, wd) => { const pts = [[x, y]]; for (let i = 0; i < n; i++) { a += rand(-.6, .6); x += Math.cos(a) * 5; y += Math.sin(a) * 4; pts.push([x, y]); if (Math.random() < .12 && wd > .8) walk(x, y, a + rand(-1.2, 1.2), n / 2 | 0, wd * .6); } s.cracks.push({pts, wd}); };
      for (let i = 0; i < 5; i++) walk(rand(w * .35, w), rand(-4, h + 4), rand(0, TAU), 16, rand(1.4, 2.4));
      s.embers = Array.from({length: 20}, () => [rand(w * .3, w), rand(0, h), rand(4, 10), rand(0, 6)]);
    },
    draw(g, w, h, t, s) {
      g.drawImage(s.rock, 0, 0, w, h);
      g.save(); g.lineCap = 'round'; g.lineJoin = 'round';
      for (const pass of [[6, 'rgba(255,80,10,.25)', 'lighter'], [s => s.wd * 1.6, '#ff6a14', 'source-over'], [s => s.wd * .6, '#ffe08a', 'lighter']]) {
        const [wd, col, op] = pass; g.globalCompositeOperation = op;
        for (const c of s.cracks) {
          const pulse = .55 + .45 * Math.sin(t * 2.2 - c.pts[0][0] * .05);
          g.globalAlpha = pulse; g.strokeStyle = col; g.lineWidth = typeof wd === 'function' ? wd(c) : wd * c.wd;
          g.beginPath(); c.pts.forEach(([x, y], i) => (i ? g.lineTo(x, y) : g.moveTo(x, y))); g.stroke();
        }
      }
      g.restore();
      glow(g, w * .8, h * .55, 50, '255,90,20', .3 + .15 * Math.sin(t * 1.5));
      g.save(); g.globalCompositeOperation = 'lighter';
      for (const e of s.embers) { e[1] -= e[2] / 60; if (e[1] < -2) { e[1] = h + 2; e[0] = rand(w * .3, w); } g.fillStyle = `rgba(255,190,90,${.4 + .5 * Math.sin(t * 7 + e[3])})`; g.fillRect(e[0], e[1], 1.3, 1.3); }
      g.restore();
      finish(g, w, h, t);
    },
  });

  // 8. ABYSS JELLYFISH — bioluminescent jellyfish pulsing in the deep.
  PLATES.push({
    name: 'Derin Okyanus', sub: 'Biyolüminesans', color: '#3a7bff', accent: '120,200,255',
    build(w, h, s) {
      s.bg = blurred(w, h, 2, (g) => { g.fillStyle = grad(g, 0, 0, 0, h, [[0, '#0a2a5c'], [1, '#020814']]); g.fillRect(0, 0, w, h);
        for (let i = 0; i < 5; i++) { g.fillStyle = 'rgba(120,180,255,.06)'; g.beginPath(); const x = w * (.4 + i * .13); g.moveTo(x, 0); g.lineTo(x + 8, 0); g.lineTo(x + 26, h); g.lineTo(x + 14, h); g.fill(); } });
      s.jelly = [{x: .76, y: .42, s: 1, ph: 0, c: '120,220,255'}, {x: .92, y: .62, s: .62, ph: 1.7, c: '255,130,220'}, {x: .58, y: .7, s: .45, ph: 3.1, c: '170,140,255'}];
      s.plank = Array.from({length: 40}, () => [rand(0, w), rand(0, h), rand(0, 6), rand(.3, 1)]);
    },
    draw(g, w, h, t, s) {
      g.drawImage(s.bg, 0, 0, w, h);
      g.save(); g.globalCompositeOperation = 'lighter';
      for (const p of s.plank) { p[1] -= .08; if (p[1] < 0) p[1] = h; g.fillStyle = `rgba(150,220,255,${.2 + .5 * Math.max(0, Math.sin(t * 1.5 + p[2]))})`; g.fillRect(p[0] + Math.sin(t + p[2]) * 2, p[1], p[3], p[3]); }
      g.restore();
      for (const j of s.jelly) {
        const pulse = Math.sin(t * 2.4 + j.ph), x = w * j.x, y = h * j.y - pulse * 1.5, R = 11 * j.s * (1 + pulse * .08), Hh = 8 * j.s * (1 - pulse * .1);
        glow(g, x, y, R * 3, j.c, .45);
        g.save(); g.globalCompositeOperation = 'lighter';
        for (let k = 0; k < 6; k++) {
          const tx = x - R * .7 + k * R * .28; g.strokeStyle = `rgba(${j.c},.35)`; g.lineWidth = .6 * j.s;
          g.beginPath(); g.moveTo(tx, y + 1);
          for (let yy = 0; yy < 26 * j.s; yy += 2) g.lineTo(tx + Math.sin(t * 2.5 + k + yy * .25 + j.ph) * 2.2 * j.s, y + 1 + yy);
          g.stroke();
        }
        g.fillStyle = radial(g, x, y - Hh * .3, 1, R, [[0, `rgba(255,255,255,.9)`], [0.35, `rgba(${j.c},.65)`], [1, `rgba(${j.c},.08)`]]);
        g.beginPath(); g.ellipse(x, y, R, Hh, 0, Math.PI, TAU); g.quadraticCurveTo(x, y + Hh * .45, x - R, y); g.fill();
        g.strokeStyle = `rgba(${j.c},.9)`; g.lineWidth = .7; g.beginPath(); g.ellipse(x, y, R, Hh, 0, Math.PI, TAU); g.stroke();
        g.restore();
      }
      finish(g, w, h, t);
    },
  });

  // 9. ROYAL GOLD — black velvet, gold filigree scrolls and a faceted ruby with a light sweep.
  PLATES.push({
    name: 'Kraliyet', sub: 'Taht varisi', color: '#d9a640', accent: '240,200,110',
    build(w, h, s) {
      s.bg = (() => { const [c, g] = off(w, h);
        g.fillStyle = radial(g, w * .8, h * .5, 2, w * .7, [[0, '#2a0d1a'], [1, '#07040a']]); g.fillRect(0, 0, w, h);
        for (let i = 0; i < 400; i++) { g.fillStyle = `rgba(255,255,255,${rand(0, .025)})`; g.fillRect(rand(0, w), rand(0, h), 1, 1); }
        const gold = grad(g, 0, 0, w, h, [[0, '#7a5718'], [0.45, '#ffe39a'], [0.6, '#c8902c'], [1, '#8a641f']]);
        g.strokeStyle = gold; g.lineCap = 'round';
        const scroll = (x, y, r, dir, wd) => { g.lineWidth = wd; g.beginPath();
          for (let a = 0; a < 4.6; a += .1) { const rr = r * (1 - a / 6.5); g.lineTo(x + dir * Math.cos(a + Math.PI) * rr, y + Math.sin(a + Math.PI) * rr); } g.stroke(); };
        const cx = w * .8, cy = h * .5;
        for (const d of [-1, 1]) {
          g.lineWidth = 1.1; g.beginPath(); g.moveTo(cx + d * 10, cy); g.bezierCurveTo(cx + d * 22, cy - 14, cx + d * 36, cy + 12, cx + d * 52, cy - 4); g.stroke();
          scroll(cx + d * 24, cy - 6, 6, d, .9); scroll(cx + d * 40, cy + 6, 5, -d, .8); scroll(cx + d * 54, cy - 6, 4, d, .7);
          g.lineWidth = .7; g.beginPath(); g.moveTo(cx + d * 10, cy + 2); g.bezierCurveTo(cx + d * 20, cy + 16, cx + d * 32, cy - 10, cx + d * 46, cy + 10); g.stroke();
        }
        g.lineWidth = .8; g.beginPath(); g.arc(cx, cy, 12.5, 0, TAU); g.stroke();
        return c; })();
    },
    draw(g, w, h, t, s) {
      g.drawImage(s.bg, 0, 0, w, h);
      const cx = w * .8, cy = h * .5;
      glow(g, cx, cy, 26, '255,40,80', .45 + .1 * Math.sin(t * 2));
      // Brilliant-cut ruby: crown facets lit from the top-left.
      const R = 9; g.save(); g.translate(cx, cy);
      const pts = Array.from({length: 8}, (_, i) => [Math.cos(i * TAU / 8 - Math.PI / 8) * R, Math.sin(i * TAU / 8 - Math.PI / 8) * R]);
      pts.forEach((p, i) => { const q = pts[(i + 1) % 8]; const l = .35 + .65 * ((Math.cos(i * TAU / 8 + 2.3 + Math.sin(t) * .3) + 1) / 2);
        g.fillStyle = `rgb(${120 + 135 * l | 0},${10 + 40 * l | 0},${30 + 50 * l | 0})`; g.beginPath(); g.moveTo(0, 0); g.lineTo(...p); g.lineTo(...q); g.fill(); });
      g.fillStyle = 'rgba(255,120,150,.6)'; g.beginPath(); pts.forEach((p, i) => (i ? g.lineTo(p[0] * .45, p[1] * .45) : g.moveTo(p[0] * .45, p[1] * .45))); g.fill();
      g.strokeStyle = 'rgba(255,220,230,.5)'; g.lineWidth = .4; g.beginPath(); pts.forEach((p, i) => (i ? g.lineTo(...p) : g.moveTo(...p))); g.closePath(); g.stroke();
      g.restore();
      // Diagonal light sweep across the gold work.
      const sx = ((t * .3) % 1.8 - .4) * w;
      g.save(); g.globalCompositeOperation = 'lighter'; g.transform(1, 0, -.6, 1, 0, 0);
      g.fillStyle = grad(g, sx - 26, 0, sx + 26, 0, [[0, 'rgba(255,230,170,0)'], [0.5, 'rgba(255,230,170,.35)'], [1, 'rgba(255,230,170,0)']]);
      g.fillRect(sx - 26, 0, 52, h); g.restore();
      for (let i = 0; i < 5; i++) { const a = Math.max(0, Math.sin(t * 2 + i * 1.9)) ** 14; if (a < .05) continue;
        const x = cx + Math.cos(i * 1.3) * (16 + i * 7), y = cy + Math.sin(i * 2.1) * 12;
        g.globalAlpha = a; g.fillStyle = '#fff4d0'; g.fillRect(x - .4, y - 4, .8, 8); g.fillRect(x - 4, y - .4, 8, .8); g.globalAlpha = 1; }
      finish(g, w, h, t);
    },
  });

  // 10. FIREFLY FOREST — misty layered pines under a moon, fireflies drifting through.
  PLATES.push({
    name: 'Ateş Böcekli Orman', sub: 'Gece yürüyüşü', color: '#7bbf4a', accent: '',
    build(w, h, s) {
      const pines = (g, base, hmin, hmax, col, step) => {
        g.fillStyle = col;
        for (let x = rand(-4, 2); x < w + 6; x += rand(step * .6, step)) {
          const th = rand(hmin, hmax), tw = th * .42;
          g.beginPath(); g.moveTo(x, base - th);
          for (let k = 1; k <= 4; k++) { const y = base - th + th * k / 4, ww = tw * k / 4; g.lineTo(x + ww, y); g.lineTo(x + ww * .45, y); }
          for (let k = 4; k >= 1; k--) { const y = base - th + th * k / 4, ww = tw * k / 4; g.lineTo(x - ww * .45, y); g.lineTo(x - ww, y); }
          g.closePath(); g.fill(); g.fillRect(x - .8, base - 2, 1.6, h);
        }
      };
      s.far = blurred(w, h, 1.4, (g) => pines(g, h * .8, 16, 26, 'rgba(40,70,90,.9)', 10));
      s.mid = blurred(w, h, .5, (g) => pines(g, h * .92, 22, 34, '#132a2e', 12));
      s.near = (() => { const [c, g] = off(w, h); pines(g, h + 4, 30, 46, '#050d0e', 16); return c; })();
      s.flies = Array.from({length: 22}, () => ({x: rand(w * .25, w), y: rand(h * .2, h * .95), ph: rand(0, 50), p: rand(.7, 1.6), o: rand(0, 6), z: rand(.6, 1.3)}));
    },
    draw(g, w, h, t, s) {
      g.fillStyle = grad(g, 0, 0, 0, h, [[0, '#0b1a33'], [0.6, '#163a4a'], [1, '#0d2328']]); g.fillRect(0, 0, w, h);
      const mx = w * .86, my = h * .3;
      glow(g, mx, my, 50, '190,220,255', .35);
      g.fillStyle = radial(g, mx - 2, my - 2, 1, 9, [[0, '#fbfdff'], [1, '#c9d8e6']]); g.beginPath(); g.arc(mx, my, 8, 0, TAU); g.fill();
      g.drawImage(s.far, (t * 1.2) % 1 - .5, 0, w, h);
      // Drifting mist bands between the tree layers.
      for (let k = 0; k < 2; k++) { const x = ((t * (4 + k * 3)) % (w * 1.4)) - w * .4;
        g.fillStyle = radial(g, x + w * .4, h * (.72 + k * .12), 0, w * .35, [[0, 'rgba(170,210,220,.22)'], [1, 'rgba(170,210,220,0)']]); g.fillRect(0, 0, w, h); }
      g.drawImage(s.mid, 0, 0, w, h);
      g.save(); g.globalCompositeOperation = 'lighter';
      for (const f of s.flies) {
        f.x += Math.sin(t * .6 + f.ph) * .18 * f.z; f.y += Math.cos(t * .5 + f.ph * 1.3) * .12 * f.z;
        const b = Math.max(0, Math.sin(t * f.p + f.o)) ** 3;
        g.fillStyle = radial(g, f.x, f.y, 0, 5 * f.z, [[0, `rgba(240,255,170,${.15 + .85 * b})`], [0.3, `rgba(200,255,90,${.4 * b})`], [1, 'rgba(180,255,80,0)']]);
        g.fillRect(f.x - 6, f.y - 6, 12, 12);
      }
      g.restore();
      g.drawImage(s.near, 0, 0, w, h);
      finish(g, w, h, t);
    },
  });


  const KEYS = ['synthwave', 'koi-lotus', 'neon-rain', 'crystal-galaxy', 'aurora-lake', 'torii-dusk', 'magma-core', 'abyss', 'royal', 'firefly-forest'];
export const NAMEPLATE_FX = Object.fromEntries(PLATES.map((p, i) => [KEYS[i], p]));
